module.exports = __webpack_public_path__ + "static/media/contactPNG.8ff1355a.png";